/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_EducationInputs */

const en_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Education`)
};

const fr_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éducation`)
};

const de_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausbildung`)
};

const it_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzione`)
};

const ru_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Образование`)
};

const es_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educación`)
};

const zh_cn2_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教育`)
};

const ja_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教育`)
};

const hi_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शिक्षा`)
};

const pt_pt2_subtitle_export_keyword_education = /** @type {(inputs: Subtitle_Export_Keyword_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educação`)
};

/**
* | output |
* | --- |
* | "Education" |
*
* @param {Subtitle_Export_Keyword_EducationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_education = /** @type {((inputs?: Subtitle_Export_Keyword_EducationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_EducationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_education(inputs)
	if (locale === "de") return de_subtitle_export_keyword_education(inputs)
	if (locale === "it") return it_subtitle_export_keyword_education(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_education(inputs)
	if (locale === "es") return es_subtitle_export_keyword_education(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_education(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_education(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_education(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_education(inputs)
	return en_subtitle_export_keyword_education(inputs)
});